import React from 'react';
import { MessageCircle, Mail } from 'lucide-react';
import { contactInfo } from '../data/mock';

const waPrefill = encodeURIComponent(
  "Hi Dawn! I'd love to book a treatment with Blissfull Mobile Spa. Could you share your availability?"
);

const Footer = () => {
  return (
    <footer className="relative pb-12 pt-8">
      <div className="max-w-6xl mx-auto px-6 flex flex-col items-center gap-6">
        <div className="flex items-center gap-4">
          <a
            href={`https://wa.me/${contactInfo.whatsappIntl}?text=${waPrefill}`}
            target="_blank"
            rel="noreferrer"
            aria-label="WhatsApp Dawn"
            className="group inline-flex items-center justify-center w-14 h-14 rounded-full border-2 border-white/70 text-white hover:bg-white hover:text-rose-500 transition-all duration-500 shadow-lg hover:scale-110"
          >
            <MessageCircle size={22} strokeWidth={1.5} />
          </a>
          <a
            href={`mailto:${contactInfo.email}?subject=${encodeURIComponent('Booking Enquiry - Blissfull Mobile Spa')}`}
            aria-label="Email Dawn"
            className="group inline-flex items-center justify-center w-14 h-14 rounded-full border-2 border-white/70 text-white hover:bg-white hover:text-rose-500 transition-all duration-500 shadow-lg hover:scale-110"
          >
            <Mail size={22} strokeWidth={1.5} />
          </a>
        </div>

        <div className="text-center text-white/90 text-sm font-light" style={{ fontFamily: "'Josefin Sans', sans-serif" }}>
          <p className="tracking-wider">
            &copy; Blissfull Mobile Spa | All rights reserved |{' '}
            <a href="#terms" className="underline underline-offset-4 hover:text-white">
              Terms &amp; Conditions
            </a>
          </p>
          <p className="mt-2 text-xs text-white/70 tracking-wider">
            WhatsApp {contactInfo.whatsapp} &middot; {contactInfo.email}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
